module.exports = __webpack_public_path__ + "assets/img/2.091cef25.jpg";